'use client';

import React__default, { useEffect } from 'react';
import { getCookie, setCookie } from '../../Utils/cookie.js';
import useHog from '../hooks/useHog/index.js';

var VNW_DOMAIN = '.vietnamworks.com';
// This HogProvider is used to centralize PostHog.
// In the future, any further requirements or changes can
// easily be updated here.
var HogProvider = function (props) {
    var children = props.children;
    var trackingQueue = useHog().trackingQueue;
    var detectSocialAuth = function () {
        var registerProvider = getCookie('VNW_REGISTER_PROVIDER');
        var loginProvider = getCookie('VNW_LOGIN_PROVIDER');
        if (!loginProvider && !registerProvider) {
            return;
        }
        var isSignedUp = registerProvider !== null && registerProvider !== '';
        // Register
        if (isSignedUp) {
            trackingQueue({
                eventName: 'js_registration:account_verify_success',
                properties: {
                    isSignedupByEmail: registerProvider === 'email',
                    isSignedupByFacebook: registerProvider === 'facebook',
                    isSignedupByGoogle: registerProvider === 'google'
                }
            });
            setCookie('VNW_REGISTER_PROVIDER', '', -1, VNW_DOMAIN);
            return;
        }
        if (!loginProvider) {
            return;
        }
        // Login
        trackingQueue({
            eventName: 'js_registration:login_success',
            properties: {
                isEmail: loginProvider === 'email',
                isFacebook: loginProvider === 'facebook',
                isGoogle: loginProvider === 'google'
            }
        });
        setCookie('VNW_LOGIN_PROVIDER', '', -1, VNW_DOMAIN);
    };
    useEffect(function () {
        // if (!posthogConfig.host || !posthogConfig.key) {
        //     console.error('Missing PostHog Config!')
        //     return
        // }
        // posthog.init(posthogConfig.key, {
        //     api_host: posthogConfig.host ?? 'https://us.i.posthog.com',
        //     capture_pageleave: false,
        //     person_profiles: 'identified_only',
        //     // Include or don't include webdriver, crawler, bot
        //     // opt_out_useragent_filter = false => Don't record tracking from bot, webdriver, Unkown user-agent
        //     opt_out_useragent_filter: posthogConfig.options?.optOutUserAgentFilter ?? false,
        //     loaded: (posthog) => {
        //         if (posthogConfig.options?.debugMode) {
        //             posthog.debug()
        //         }
        //     }
        // })
        // TrackingQueue will await until posthog is ready
        detectSocialAuth();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // return <PostHogProvider client={posthog}>{children}</PostHogProvider>
    return React__default.createElement(React__default.Fragment, null, children);
};

export { HogProvider as default };
//# sourceMappingURL=index.js.map
